export default "__VITE_ASSET__CJI03g0u__"